import React from 'react';
import { Row } from 'antd';

const FormButtonsContainer = ({ children }) => {
  return <Row justify="end">{children}</Row>;
};

export default FormButtonsContainer;
